import React, { useState, useEffect, useMemo } from 'react';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import * as S from '../styles';
import api from '../../../../_core/api';
import { handleErrors, success } from '../../../../_core/services/toast';
import { FullScreenLoading } from '../../../../_core/_components/fullscreen-loading';
import { Button, Input, Option, PaginatedTable } from '../../../../_core/_components';
import ConfirmationModal from '../../../../_core/_components/confirmation-modal';
import Modal from './modal';

export type DebtType = {
  idAjzTipoDivida: number;
  codTipoDivida: string;
  descricao: string;
};

const TipoDivida: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [registerList, setRegisterList] = useState<DebtType[]>([]);
  const [page, setPage] = useState(1);
  const [pageInfo, setPageInfo] = useState({
    currentPage: 1,
    totalPages: 0,
  });
  const [searchText, setSearchText] = useState('');
  const [selectedRegister, setSelectedRegister] = useState<DebtType | null>(null);
  const [creationModalOpen, setCreationModalOpen] = useState<any>(false);

  useEffect(() => {
    getData();
  }, [page]);

  const getData = async () => {
    setLoading(true);
    try {
      const { data } = await api.get<DebtType[]>(`/setup/rules/tipo-divida`);
      setRegisterList(data);
    } catch (e) {
      handleErrors(e);
    }
    setLoading(false);
  };

  const filteredItems = useMemo(() => {
    if (searchText) {
      const filtered = registerList.filter(reg => reg.codTipoDivida.toUpperCase().includes(searchText.toUpperCase()));
      return filtered;
    }
    return registerList;
  }, [searchText, registerList]);

  const renderedData = useMemo(() => {
    if (filteredItems.length > 0) {
      return filteredItems.map(item => ({
        ...item,
        excluir: (
          <IconButton
            aria-controls="simple-menu"
            aria-haspopup="true"
            color="primary"
            component="span"
            id={item.idAjzTipoDivida.toString()}
            onClick={() => setSelectedRegister(item)}
          >
            <DeleteIcon />
            <S.IconLabel>Remover</S.IconLabel>
          </IconButton>
        ),
      }));
    }
    return [];
  }, [filteredItems]);

  const onSave = async (payload: any) => {
    setLoading(true);
    try {
      await api.post('/setup/rules/tipo-divida', {
        codTipoDivida: payload.conta,
        descricao: payload.desc,
      });
      setSelectedRegister(null);
      setCreationModalOpen(false);
      getData();
    } catch (error) {
      handleErrors(error);
    }
    setLoading(false);
  };

  const onRemove = async () => {
    try {
      await api.delete(`/setup/rules/tipo-divida/${selectedRegister?.idAjzTipoDivida}`);
      success('O registro foi removido');
      getData();
      setSelectedRegister(null);
    } catch (e) {
      handleErrors(e);
    }
    setSelectedRegister(null);
  };

  return (
    <S.DataContainer>
      <FullScreenLoading isEnabled={loading} />
      {creationModalOpen && <Modal onSave={onSave} onClose={() => setCreationModalOpen(false)} />}

      {selectedRegister && (
        <ConfirmationModal
          open={Boolean(selectedRegister)}
          handleOk={() => onRemove()}
          handleCancel={() => setSelectedRegister(null)}
          text={`Confirma exclusão do tipo de dívida ${selectedRegister.codTipoDivida} ?`}
        />
      )}
      <S.TopBar>
        <S.SearchBar>
          <S.SearchField>
            <Input label="Buscar" state={[searchText, setSearchText]} />
          </S.SearchField>
        </S.SearchBar>
        <Button text="Criar novo" onClick={() => setCreationModalOpen(true)} />
      </S.TopBar>
      {renderedData.length > 0 && (
        <S.TableContainer>
          <PaginatedTable
            columns={[
              { label: 'ID', key: 'idAjzTipoDivida' },
              { label: 'Tipo dívida', key: 'codTipoDivida' },
              { label: 'Descrição', key: 'descricao' },
              { label: '', key: 'excluir' },
            ]}
            data={renderedData}
            pagination={pageInfo}
            onChangePage={setPage}
          />
        </S.TableContainer>
      )}
    </S.DataContainer>
  );
};

export default TipoDivida;
